import { LOCALES, type Locale } from './index';

/**
 * Idioma escolhido pelo usuário, em cookie. O mesmo cookie do banner de sugestão do site, para que
 * a escolha feita no site valha no app (e vice-versa). No app a URL não carrega idioma, então sem
 * isto todo F5 voltava para o português.
 */
export const COOKIE_IDIOMA = 'vyxora_lang';
const UM_ANO = 60 * 60 * 24 * 365;

export function lerIdiomaSalvo(): Locale | null {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp(`(^| )${COOKIE_IDIOMA}=([^;]+)`));
  const v = m ? decodeURIComponent(m[2]) : null;
  return v && (LOCALES as readonly string[]).includes(v) ? (v as Locale) : null;
}

export function salvarIdioma(idioma: Locale) {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_IDIOMA}=${encodeURIComponent(idioma)}; path=/; max-age=${UM_ANO}; samesite=lax`;
}
